<script setup lang="ts">
import { AlertCircle, CheckCircle2, Info } from 'lucide-vue-next'
import { useToast } from '@/composables/useToast'

const { items, dismiss } = useToast()
</script>

<template>
  <div class="pointer-events-none fixed inset-x-0 top-3 z-[60] flex flex-col items-center gap-2 px-3">
    <TransitionGroup
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="opacity-0 -translate-y-2"
      leave-active-class="transition duration-150 ease-in"
      leave-to-class="opacity-0"
    >
      <div
        v-for="t in items"
        :key="t.id"
        class="card pointer-events-auto flex max-w-[560px] items-start gap-2.5 px-4 py-2.5 shadow-[var(--zr-shadow-pop)]"
        role="status"
        @click="dismiss(t.id)"
      >
        <CheckCircle2 v-if="t.tone === 'ok'" class="mt-0.5 size-4 shrink-0 text-[color:var(--zr-ok)]" />
        <AlertCircle v-else-if="t.tone === 'bad'" class="mt-0.5 size-4 shrink-0 text-[color:var(--zr-bad)]" />
        <Info v-else class="mt-0.5 size-4 shrink-0 text-[color:var(--zr-brand)]" />
        <p class="text-[13.5px] leading-6">{{ t.text }}</p>
      </div>
    </TransitionGroup>
  </div>
</template>
